require('reading/logs/log_calendar.scss');
var moment = require("moment");

class LogCalendar extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			day: moment().date(), month: moment().month(),
			year: moment().year(), monthCount: 0,
		};
	}

	prevMonth() {
		var monthCount = this.state.monthCount - 1;
		var prevDate = moment().add(monthCount, 'months')		
		var prevMonth = prevDate.month();
		var year = prevDate.year();
		this.setState({ month: prevMonth, year: year, monthCount: monthCount })
	}

	nextMonth() {
		var monthCount = this.state.monthCount + 1;
		var nextDate = moment().add(monthCount, 'months')
		var nextMonth = nextDate.month();
		var year = nextDate.year();
		this.setState({ month: nextMonth, year: year, monthCount: monthCount })
	}

	setStateToToday() {
		this.setState({ day: moment().date(), month: moment().month(), 
			year: moment().year(), monthCount: 0
		})
	}

	getDayData() {
		// [{ date: "2017-04-27", item: "10 minutes" }, { date: "2017-04-05", item: "20 minutes" }, { date: "2017-04-03", item: "1 question" },  { date: "2017-04-05", item: "1 question" }]
		var byDate = _.groupBy(this.props.logs, "log_date");
		// this.props.dataArray
		return _.flatten(_.map(byDate, function(logs, date) {
			var minutes = _.reduce(logs, function(memo, log) {
				return memo + log.minutes;
			}, 0);
			
			var minutesLine = minutes + " " + $wr.pluralize("minute", minutes);

			return { date: date, item: minutesLine };
		}));
	}

	render() {
		var currentDateInState = new Date(this.state.year, this.state.month, this.state.day);
		var currentMonth = currentDateInState.getMonth();
		var currentYear = currentDateInState.getFullYear();

		var currentMonthStartDate = new Date(currentYear, currentMonth, 1);
		var currentMonthEndDate = new Date(currentYear, currentMonth + 1, 0);

		// offset tells us on which day the first of the month falls
		var offset = -(currentMonthStartDate.getDay());
		var daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
		//weekOffSet combines the offset and days in the month to calculate how many days in total a month took up on the calendar
		var weekOffSet = Math.abs(offset) + daysInCurrentMonth;
		//by dividing weekoffset by 7 we can see how many weeks a month took up on the calendar
		var currentNumWeeks = Math.ceil(weekOffSet/7);

		var weeks = [];
		var names=[];
		for (var i=0; i<7; i++) {
			names.push(<td className="dayNames" key={ i }>{ LogCalendar.DAY_NAMES[i] }</td>)
		}
		//pushing names of days into weeks array
		weeks.push(<tr key="header">{ names }</tr>);

		var dataData = this.getDayData();

		for (var y=0; y < currentNumWeeks; y++) {
			var days = [];
			var result = [];

			for (var i = 0; i < 7; i++) {
				result = [];
				var dayCount = (i + 1) + (y * 7) + offset;
				if (dayCount < 1 || dayCount > currentMonthEndDate.getDate()) {
					dayCount = ""
				} else {
					var newDate = moment([this.state.year, this.state.month, dayCount]).format("YYYY-MM-DD")
					var filterDate = _.filter(dataData, function(num, index) {
						if (num.date == newDate) {
							result.push(<p key={ index } className="data-result">{ num.item }</p>)
						}
					});
				}
				// highlight if this cell is today's date
				if (dayCount == moment().date()
					&& currentMonth == moment().month()
					&& currentYear == moment().year()) {
					var cellClass = "dayBlank todayHighLight";
				} else {
					var cellClass = "dayBlank";
				}
				days.push(
					<td className={ cellClass } key={ i }>
						<p className="dateNumber">{ dayCount }</p>
						<div className="data-result-all">{ result }</div>
					</td>
				)
			}
			// pushing the day numbers into weeks array
			weeks.push(<tr key={ y }>{ days }</tr>);
		}

		return (
		  <div className="logCalendar">
			  <div>
				  <p className="currentMonth"> 
				  	{ LogCalendar.MONTH_NAMES[currentMonth] } {" "}  { currentYear }
				  </p>
					  <div className="btngroup">

						  <button onClick={ this.prevMonth } type="button" >
							  <span className="glyphicon glyphicon-chevron-left"></span>
						  </button>

						  <button onClick={ this.setStateToToday } className="button">Today</button>

						  <button onClick={ this.nextMonth } type="button" >
							  <span className="glyphicon glyphicon-chevron-right"></span>
						  </button>

					  </div>
			  </div>

				  <table>
					  <tbody>
						{ weeks }
					  </tbody>
				  </table>
			</div>

		)
	}
}

LogCalendar.propTypes = StrictPropTypes({
	logs: PropTypes.array.isRequired
});

LogCalendar.DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
LogCalendar.MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

module.exports = LogCalendar;



// WEBPACK FOOTER //
// ./modules/components/reading/logs/LogCalendar.js